import React from "react";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

class AlertPopup extends React.PureComponent {
  render() {
    return (
      <div className="alert-popup">
        <div className="icon">
          <ErrorOutlineIcon />
        </div>
        <div className="content">Vui lòng chọn game!</div>
      </div>
    );
  }
}

export default AlertPopup;
